/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import "../../../_metronic/_assets/sass/pages/Announcements/Announcements.scss";
import {
  Paper,
  MuiThemeProvider,
  Dialog,
  DialogContent,
  ButtonGroup,
  Button,
  useMediaQuery,
  createTheme,
  DialogTitle,
  Tooltip,
} from "@material-ui/core";
import { Reorder, Apps, Delete, Add } from "@material-ui/icons";
import { bindActionCreators } from "redux";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import moment from "moment";

import AnnouncementsDialog from "./AnnouncementsDialog";

import {
  getAnnouncementsStaff,
  defaultAnnouncement,
  getAnnouncement,
  deleteAnnouncement,
} from "../../crud/api/annc.crud";
import { setLoader } from "../../../redux/ducks/load.duck";
import * as anncDUCK from "../../../redux/ducks/annc.duck";
import { setAlert } from "../../../redux/ducks/alert.duck";
import { useSelector } from "react-redux";

import { toAbsoluteUrl } from "../../../_metronic/_helpers/AssetsHelpers";
import CustomTableFooter from "../../utils/CustomTableFooter";
import CardViewAnnouncements from "../../Components/Announcements/CardViewAnnouncements";
import ContentsStaff from "./ContentsStaff";
import CardPaginator from "../../Components/CardPaginator";
import NotifyModal from "../Contens/NotifyModal";

const Announcements = ({
  anncs,
  user,
  anncActions,
  settingLoader,
  setAlert,
  school,
}) => {
  const [isGrid, setIsGrid] = useState(false);
  // TZ-798: small page size for the card view so it paginates like Zone App.
  // Note: in this file isGrid === true is the table/list view (the card view is
  // isGrid === false). The list view keeps its legacy size (undefined → all_items
  // sizing); the card view uses CARD_PAGE_SIZE.
  const CARD_PAGE_SIZE = 12;
  const perPageFor = (isListView) => (isListView ? undefined : CARD_PAGE_SIZE);
  const [activeButton, setActiveButton] = useState("published"); // valor inicial

  const [dialog, setDialog] = useState("close");
  const [htmlContent, setHtmlContent] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [query, _setQuery] = useState("");
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const isDesktop = useMediaQuery("(min-width: 992px)");
  const { selected_school } = useSelector((state) => state.school);

  const [selectedAnnc, setSelectedAnnc] = useState(null);

  useEffect(() => {
    if (school && school.id) {
      if (query && query.length > 1) {
        getAnnouncementsStaff(
          anncActions.setAnncs,
          user.id,
          1,
          school.id,
          query,
          !isGrid,
          perPageFor(isGrid)
        );
      } else
        getAnnouncementsStaff(
          anncActions.setAnncs,
          user.id,
          1,
          school.id,
          undefined,
          !isGrid,
          perPageFor(isGrid)
        );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, anncActions.setAnncs, school, user.id, selected_school]);

  const deleteAnnc = (id) => {
    setAlert({
      title: "Delete Hub Content",
      message: "Are you sure to permanently delete this Hub Content?",
      btn_msg: "Delete Hub Content",
      action: () => deleteAnnouncement(anncActions.deleteAnncs, id),
    });
  };

  const handleOpenNotify = async (id) => {
    const annc = await getAnnouncement(anncActions.setAnnc, id);
    setSelectedAnnc({
      contentId: annc.payload.id,
      contentTitle: annc.payload.title,
    });
    setShowNotificationModal(true);
  };

  const columns = [
    {
      name: "full_name_staff",
      label: "Staff",
      options: {
        filter: false,
        sort: false,
        display: user.is_admin,
      },
    },

    {
      name: "id",
      label: "id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "title",
      label: "Title",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "file_type",
      label: "Type",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value) => {
          let src;
          let type = value ? value.toLowerCase() : "";

          if (type === "audio")
            src = `${toAbsoluteUrl("/media/assets/audio-icon.png")}`;
          if (type === "text" || type === "html")
            src = `${toAbsoluteUrl("/media/assets/text-icon.png")}`;
          if (type === "link")
            src = `${toAbsoluteUrl("/media/assets/link-icon.png")}`;
          if (type === "video")
            src = `${toAbsoluteUrl("/media/assets/video-icon.png")}`;
          if (type === "pdf")
            src = `${toAbsoluteUrl("/media/assets/pdf-icon.png")}`;
          if (type === "document")
            src = `${toAbsoluteUrl("/media/assets/docx-icon.png")}`;
          if (type === "image") src = `${toAbsoluteUrl("/media/assets/image")}`;

          return (
            src && <img width="40px" height="40px" src={src} alt="file_type" />
          );
        },
      },
    },
    {
      name: "read",
      label: "Read",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "liked",
      label: "Liked",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "created_at_str",
      label: "Created at",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => <>{moment(value).format("DD-MMM-YYYY")}</>,
      },
    },

    {
      name: "id",
      label: "Actions",
      options: {
        display: !user.is_admin,
        filter: false,
        sort: false,
        customBodyRender: (value, meta) => (
          <div className="d-flex">
            <Tooltip title="Edit Team" placement="top">
              <a
                id={`edit_team_btn_${value}`}
                className="btn btn-icon btn-sm btn-light btn-hover-primary "
                onClick={() => openDialog("editing", value)}
              >
                <i className="fas fa-edit text-primary" />
              </a>
            </Tooltip>
            <Tooltip title="Delete Team" placement="top">
              <a
                id={`delete_team_btn_${value}`}
                className="btn btn-icon btn-sm btn-light btn-hover-danger text-danger mx-3"
                onClick={() => deleteAnnc(value)}
              >
                <Delete />
              </a>
            </Tooltip>
          </div>
        ),
      },
    },
  ];

  // TZ-798: shared page-change for My Published (used by both the table footer
  // and the card-grid paginator).
  const goToPage = (mPage) => {
    settingLoader(true);
    const promise = getAnnouncementsStaff(
      anncActions.setAnncs,
      user.id,
      mPage,
      school.id,
      query,
      // TZ-798: match the initial load's page size so paging stays consistent —
      // card view paginates by CARD_PAGE_SIZE, table keeps its legacy size.
      !isGrid,
      perPageFor(isGrid)
    );
    if (promise) {
      promise.catch(() => {}).finally(() => settingLoader(false));
    }
  };

  const options = {
    serverSide: true,
    rowsPerPageOptions: [],
    rowsPerPage: anncs.rowsPerPage,
    page: anncs.page,
    count: anncs.count,
    rowHover: false,
    search: false,
    sort: false,
    print: false,
    filter: false,
    viewColumns: false,
    download: false,
    selectableRows: "none",
    tableBodyMaxHeight: isDesktop ? "50em" : "357px",
    textLabels: {
      body: {
        noMatch: "No data",
      },
      pagination: {
        next: "Next",
        previous: "Previous",
        rowsPerPage: "Rows:",
        displayRows: "of",
      },
    },
    downloadOptions: {
      filename: "announcements.csv",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayRowsOnly: true,
      },
    },
    customFooter: (count, page, rowsPerPage) => (
      <CustomTableFooter
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        onChangePage={goToPage}
      />
    ),
  };

  const openDialog = (mode, id = null) => {
    switch (mode) {
      case "create":
        settingLoader(true);
        anncActions.setAnnc(defaultAnnouncement);
        setDialog(mode);
        break;
      case "editing":
        settingLoader(true);
        getAnnouncement(anncActions.setAnnc, id).then(() => setDialog(mode));
        break;
      case "close":
        setDialog(mode);
        setTimeout(() => {
          anncActions.setAnnc(defaultAnnouncement);
        }, 500);
        break;
      default:
        console.error("Invalid dialog mode");
    }
  };

  const HtmlDialogContent = () => (
    <Dialog
      open={Boolean(htmlContent)}
      onClose={() => setHtmlContent("")}
      fullWidth
      maxWidth="md"
      id="announce_content_dialog"
    >
      <DialogTitle>Content</DialogTitle>
      <DialogContent>
        <span dangerouslySetInnerHTML={{ __html: htmlContent }} />
      </DialogContent>
    </Dialog>
  );

  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            padding: "4px 10px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            // eslint-disable-next-line no-useless-computed-key
            ["@media(min-width: 960px)"]: {
              maxWidth: 200,
            },
          },
        },
        MUIDataTableToolbar: {
          root: {
            background:
              "linear-gradient(125deg, rgba(17, 151, 192, 1) 25%, rgba(4, 7, 25, 1) 100%)",
            minHeight: "50px",
            height: "50px",
            borderTopLeftRadius: "3px",
            borderTopRightRadius: "3px",
            color: "white",
          },
          icon: {
            color: "white",
          },
          titleRoot: {
            display: "none",
          },
          left: {
            marginLeft: 80,
          },
        },
        MUIDataTable: {
          root: {
            display: "block",
          },
        },
        MuiTable: {
          root: {
            display: "table",
          },
        },
        MUIDataTableHeadCell: {
          root: {
            background: "rgb(22 147 186) !important",
          },
          fixedHeader: {
            zIndex: 90,
            fontWeight: "bold",
            color: "white",
          },
        },
      },
    });

  return (
    <>
      <p>Manage your educational content and learning materials</p>
      <div className="pb-4 d-flex justify-content-between align-items-end">
        <ButtonGroup
          variant="text"
          style={{
            right: "175px",
            position: "absolute",
            zIndex: 1,
          }}
        >
          <Button
            id="announce_grid_view_btn"
            style={{ color: "black", border: "none" }}
            onClick={() => setIsGrid(false)}
          >
            <Apps />
          </Button>

          <Button
            id="announce_list_view_btn"
            style={{ color: "black" }}
            onClick={() => setIsGrid(true)}
          >
            <Reorder />
          </Button>
        </ButtonGroup>

        {!user.is_admin && (
          <Button
            id="create_announce_btn"
            variant="contained"
            color="secondary"
            onClick={() => openDialog("create")}
          >
            <Add /> Upload Content
          </Button>
        )}
      </div>
      <Paper>
        <div className="announcements-toggle">
          <Button
            className={`btn-announcements ${
              activeButton === "published" ? "btn-active-announcements" : ""
            }`}
            onClick={() => setActiveButton("published")}
          >
            My Published
          </Button>
          <Button
            className={`btn-announcements ${
              activeButton === "zone" ? "btn-active-announcements" : ""
            }`}
            onClick={() => setActiveButton("zone")}
          >
            Zone App
          </Button>
          {/* <Button
            className={`btn-announcements ${
              activeButton === "drafts" ? "btn-active-announcements" : ""
            }`}
            onClick={() => setActiveButton("drafts")}
          >
            My Drafts
          </Button> */}
        </div>
        <MuiThemeProvider theme={getMuiTheme()}>
          {activeButton === "published" &&
            (isGrid ? (
              <MUIDataTable
                title=""
                columns={columns}
                data={anncs.data}
                options={options}
              />
            ) : (
              <>
                <CardViewAnnouncements
                  anncs={anncs}
                  openDialog={openDialog}
                  deleteAnnc={deleteAnnc}
                  handleOpenNotificationModal={handleOpenNotify}
                />
                {/* TZ-798: pager for the card grid (table view has its own). */}
                <CardPaginator
                  page={anncs.page}
                  count={anncs.count}
                  rowsPerPage={anncs.rowsPerPage}
                  onChangePage={goToPage}
                />
              </>
            ))}

          {activeButton === "zone" && <ContentsStaff isGrid={isGrid} />}
        </MuiThemeProvider>
      </Paper>

      <AnnouncementsDialog isOpen={true} mode={dialog} setDialog={openDialog} />
      <NotifyModal
        open={showNotificationModal}
        setOpen={setShowNotificationModal}
        isContentProAthlete={school.is_pro_athlete}
        customContent={selectedAnnc}
      />
      <HtmlDialogContent />
    </>
  );
};

const mapStateToProps = (store) => ({
  school: store.school.selected_school,
  user: store.auth.user,
  anncs: store.annc.anncs,
});

const mapDispatchToProps = (dispatch) => ({
  settingLoader: bindActionCreators(setLoader, dispatch),
  anncActions: bindActionCreators(anncDUCK.actions, dispatch),
  setAlert: bindActionCreators(setAlert, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Announcements);
